<script setup lang="ts">
import { computed } from 'vue';

import ButtonText from '@/shared/components/UI/Buttons/ButtonText.vue';
import Modal from '@/shared/components/UI/Modal.vue';
import { useTranslations } from '@/shared/composables/useTranslations';
import { useUserStore } from '@/shared/pinia/modules/user';

const { t } = useTranslations();
const userStore = useUserStore();

const showModal = computed({
  get() {
    return userStore.showingAccountBlockedNoticeModal;
  },
  set(value) {
    if (!value) {
      userStore.closeAccountBlockedNoticeModal();
    }
  }
});

const close = () => {
  userStore.closeAccountBlockedNoticeModal();
};
</script>

<template>
  <Modal
    v-model:active="showModal"
    size="sm"
    :close-button="true"
    :close-on-escape-key="true"
    :close-on-click-outside="true"
    :always-on-top="true"
  >
    <div class="flex flex-col gap-3 p-4">
      <h1 class="text-2xl font-bold">
        {{ t('account_blocked.text_title') }}
      </h1>
      <I18nT keypath="account_blocked.text_description" tag="p">
        <a
          class="underline"
          href="/pages/membership-conditions"
          target="_blank"
          >{{ t('account_blocked.label') }}</a
        >
      </I18nT>

      <ButtonText
        theme="primary"
        size="lg"
        class="mt-2 !text-lg"
        @click="close"
      >
        {{ t('account_blocked.text_close') }}
      </ButtonText>
    </div>
  </Modal>
</template>
